/**
 * Widget data service
 * Author: sandeep.yadav@hp.com
 * Date: July  2020
 */

const baseUrl = '/os/ossui/v1/in/';
const osvHelperUrl = '/os/ws/osvHelper.tcl'
const extUIHelperUrl = '/os/extws/extUIHelper.tcl'

export const getShipmentData =  (legacy_order_no, callback) => {
  GET(baseUrl + "widgetExpert/shipmentItems/" + legacy_order_no, {}, callback)
}

export const getShipmentInfo =  (legacy_order_no, shipmentNo, callback) => {
  if (shipmentNo == null) {
    GET(baseUrl + "getShipmentInfo/" + legacy_order_no, {}, callback)
  } else {
    GET(baseUrl + "getShipmentInfo/" + legacy_order_no + "/" + shipmentNo, {}, callback)
  }   
}

export const getShipmentDetails =  (legacy_order_no, shipmentNo, tenant, callback) => {
  GET(baseUrl + "shipmentDetails/shipmentDetails/" + legacy_order_no + "/"+ shipmentNo + "/" + tenant, {}, callback)
}

export const getShipmentByCarrier =  (legacy_order_no, shipmentNo, tenant, callback) => {
  GET(baseUrl + "shipmentDetails/shipmentbyCarrier/" + legacy_order_no + "/"+ shipmentNo + "/" + tenant, {}, callback)
}

export const getShipmentHierarchy =  (legacy_order_no, shipmentNo, tenant, callback) => {
  GET(baseUrl + "shipmentDetails/shipmentHierarchy/" + legacy_order_no + "/"+ shipmentNo + "/" + tenant, {}, callback)
}

const buildShipmentOrderFilterQuery = (orderFilters = {}) => {
  const queryParts = [];
  ['order_no', 'order_type_descr', 'so_no'].forEach((fieldName) => {
    const value = orderFilters[fieldName];
    if (value !== null && typeof value !== 'undefined' && String(value).trim() !== '') {
      queryParts.push(fieldName + '=' + encodeURIComponent(String(value).trim()));
    }
  });

  if (queryParts.length === 0) {
    return '';
  }

  return '?' + queryParts.join('&');
}

export const getShipmentPeC =  (shipmentNo, tenant, orderFiltersOrCallback, callback) => {
  const hasOrderFilters = typeof orderFiltersOrCallback === 'object' && orderFiltersOrCallback !== null;
  const orderFilters = hasOrderFilters ? orderFiltersOrCallback : {};
  const cb = hasOrderFilters ? callback : orderFiltersOrCallback;

  GET(baseUrl + "shipmentDetails/pec/" + shipmentNo + "/" + tenant + buildShipmentOrderFilterQuery(orderFilters), {}, cb)
}

export const getShipmentEDIR =  (shipmentNo, tenant, orderFiltersOrCallback, callback) => {
  const hasOrderFilters = typeof orderFiltersOrCallback === 'object' && orderFiltersOrCallback !== null;
  const orderFilters = hasOrderFilters ? orderFiltersOrCallback : {};
  const cb = hasOrderFilters ? callback : orderFiltersOrCallback;

  GET(baseUrl + "shipmentDetails/edir/" + shipmentNo + "/" + tenant + buildShipmentOrderFilterQuery(orderFilters), {}, cb)
}

export const getShipmentIRL =  (shipmentNo, tenant, orderFiltersOrCallback, callback) => {
  const hasOrderFilters = typeof orderFiltersOrCallback === 'object' && orderFiltersOrCallback !== null;
  const orderFilters = hasOrderFilters ? orderFiltersOrCallback : {};
  const cb = hasOrderFilters ? callback : orderFiltersOrCallback;

  GET(baseUrl + "shipmentDetails/irl/" + shipmentNo + "/" + tenant + buildShipmentOrderFilterQuery(orderFilters), {}, cb)
}

export const getMetaData = (callback) => {
  GET(baseUrl + "widgetExpert/metadata", {}, callback)
}

export const getPackingListLink = (legacy_order_no, shipmentNo, hpdelvno, caller, callback) => {
  if (caller == "internal" || caller == "osv") {
    GET(osvHelperUrl + "?packingListLink=packingList&lon="+ legacy_order_no +"&shipmentno="+ shipmentNo +"&hpdelvno=" + hpdelvno, {}, callback)
  } else {
    GET(extUIHelperUrl + "?packingListLink=packingList&lon="+ legacy_order_no +"&shipmentno="+ shipmentNo +"&hpdelvno=" + hpdelvno, {}, callback)
  }
}

export const getPodUrl = (legacy_order_no, shipment_no, hpdeliveryno, carriername, callback) => {
  let podDownloadURL = osvHelperUrl + '?pod=' + hpdeliveryno + '&carrier=' + carriername + '&shipmentno=' + shipment_no + '&pod_os=' + legacy_order_no;
        podDownloadURL = podDownloadURL.replace(/ /g, '+');
  GETwithTimeout(podDownloadURL, {}, 410000, callback);
}

export default getShipmentData;
